<template>
    <div class="action-bar">
        <div class="action-bar__left">
            <button class="navigation-toggle" @click="toggleNavigation"><i class="fa fa-bars"></i></button>
            <span v-if="isSaving">
                <span v-if="!feedback"><i class="fa fa-spinner fa-spin fa-fw"></i> Änderungen werden gespeichert</span>
                <span v-else :class="feedback.classname"><i :class="'fa fa-fw ' + feedback.icon"></i> {{feedback.message}}</span>
            </span>
        </div>

        <div class="action-bar__right">
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
  computed: {
    isSaving() {
      return store.state.saving > 0;
    },
    feedback() {
      return store.state.feedback;
    }
  },
  methods: {
    toggleNavigation() {
      store.commit("toggleNavigation");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ActionBar.vue